export class Helper{
    /**
     * text -> Text
     * @param {String} str
     * @returns
     */
    strToUpper(str){
        if (!str) return str;
        return str.charAt(0).toUpperCase() + str.slice(1);
    }
}
